<ng-container *ngIf="siteConfig">
  <a href="mailto:{{ siteConfig.contactUsEmail }}">{{ siteConfig.contactUsEmail }}</a>
  <p>
    {{ 'Popup.Or' | translate }}<br />
    {{ siteConfig.contactUsPhone }}<br />
  </p>
</ng-container>
